import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IconPhone, IconPin } from '../../storefront/icons';
import { STORE, STORE_MAPS_URL } from '../../storefront/storeInfo';

const ROTATE_MS = 5200;

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

const MessageBody = ({ message }) => (
  <>
    {message.icon}
    <span className="tp-announce__text" data-copy-key={message.textKey}>{message.text}</span>
    {message.cta && <span className="tp-announce__cta" data-copy-key={message.ctaKey}>{message.cta}</span>}
  </>
);

const Message = ({ message }) => {
  if (message.to) {
    return <Link to={message.to} className="tp-announce__msg-link"><MessageBody message={message} /></Link>;
  }
  if (message.href) {
    return (
      <a
        href={message.href}
        className="tp-announce__msg-link"
        {...(message.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        <MessageBody message={message} />
      </a>
    );
  }
  if (message.onClick) {
    return (
      <button type="button" className="tp-announce__msg-link" onClick={message.onClick}>
        <MessageBody message={message} />
      </button>
    );
  }
  return <span className="tp-announce__msg-link"><MessageBody message={message} /></span>;
};

// Slim ink bar above the header: address and phone on desktop, with a
// rotating set of live messages (next trade show, the visitor's trade-account
// state) in the middle.
const AnnouncementBar = ({ messages }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const count = messages.length;
  const messageKey = messages.map((message) => message.id).join('|');

  useEffect(() => {
    setIndex(0);
  }, [messageKey]);

  useEffect(() => {
    if (paused || count < 2 || prefersReducedMotion()) return undefined;
    const timer = setInterval(() => setIndex((current) => (current + 1) % count), ROTATE_MS);
    return () => clearInterval(timer);
  }, [paused, count]);

  const active = count ? index % count : 0;

  return (
    <div
      className="tp-announce"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      <div className="tp-announce__inner tp-container">
        <a
          className="tp-announce__side"
          href={STORE_MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <IconPin size={14} />
          {STORE.street} · Burleson, TX
        </a>

        <div className="tp-announce__ticker">
          {messages.map((message, i) => (
            <div
              key={message.id}
              className={`tp-announce__msg${i === active ? ' is-active' : ''}`}
              aria-hidden={i !== active}
              inert={i !== active}
            >
              <Message message={message} />
            </div>
          ))}
        </div>

        <a className="tp-announce__side tp-announce__side--end" href={STORE.tollFree.href}>
          <IconPhone size={14} />
          {STORE.tollFree.label}
          <span className="tp-announce__hours">{STORE.hours}</span>
        </a>
      </div>
    </div>
  );
};

export default AnnouncementBar;
